module.exports = __webpack_public_path__ + "static/media/19ESCAP34.378cfb1a.jpg";